import React from "react";

const LinkIcon = ({ size = 16, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M12.4372 22.8658L8.90212 26.4008C7.43656 27.8664 5.06321 27.8663 3.59889 26.4011C2.13427 24.9365 2.13427 22.5629 3.59859 21.0986L10.6699 14.0272C12.1342 12.5629 14.5078 12.5629 15.9721 14.0272C16.4603 14.5154 17.2518 14.5154 17.7399 14.0272C18.2281 13.5391 18.2281 12.7476 17.7399 12.2595C15.2992 9.81879 11.3428 9.81879 8.90212 12.2595L1.83087 19.3307C-0.609811 21.7714 -0.609811 25.7278 1.83087 28.1685C4.27125 30.6105 8.22799 30.6105 10.67 28.1685L14.205 24.6335C14.6931 24.1453 14.6931 23.3538 14.205 22.8657C13.7169 22.3775 12.9253 22.3776 12.4372 22.8658Z"
          fill="#192033"
        />
        <path
          d="M28.1692 1.83051C25.7285 -0.61017 21.7708 -0.61017 19.3301 1.83051L15.0888 6.07178C14.6007 6.55993 14.6007 7.35142 15.0888 7.83957C15.577 8.32771 16.3684 8.32771 16.8566 7.83957L21.0979 3.59829C22.5622 2.13391 24.937 2.13391 26.4014 3.59829C27.8657 5.06262 27.8657 7.43621 26.4014 8.90053L18.6238 16.6781C17.1595 18.1425 14.7859 18.1425 13.3216 16.6781C12.8335 16.19 12.042 16.19 11.5538 16.6781C11.0657 17.1663 11.0657 17.9578 11.5538 18.4459C13.9945 20.8866 17.951 20.8866 20.3916 18.4459L28.1692 10.6684C30.6098 8.22769 30.6098 4.27119 28.1692 1.83051Z"
          fill="#192033"
        />
      </g>
    </svg>
  );
};

export default LinkIcon;
